import { render, staticRenderFns } from "./ClinicOpportunities.vue?vue&type=template&id=5e8065a3"
import script from "./ClinicOpportunities.vue?vue&type=script&lang=js"
export * from "./ClinicOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports